import { render, staticRenderFns } from "./main_audit.vue?vue&type=template&id=08168d12&scoped=true&"
import script from "./main_audit.vue?vue&type=script&lang=js&"
export * from "./main_audit.vue?vue&type=script&lang=js&"
import style0 from "./main_audit.vue?vue&type=style&index=0&id=08168d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08168d12",
  null
  
)

export default component.exports